<template>
  <div id="app" class="text-n-800">
    <router-view></router-view>
    <l-dialog-wrapper />
    <l-notification-wrapper class="z-50" />
    <div id="appRoot"></div>
  </div>
</template>

<script setup lang="ts">
import { LDialogWrapper, LNotificationWrapper } from '@last/core-ui/paprika'
</script>
